"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.erc20ProxyArtifact = void 0;
const ContractArtifact_1 = require("../../ContractArtifact");
const _0_1_0_json_1 = require("./0.1.0.json");
exports.erc20ProxyArtifact = new ContractArtifact_1.ContractArtifact({
    '0.1.0': {
        abi: _0_1_0_json_1.abi,
        deployment: {
            private: {
                address: '0x2c2b9c9a4a25e24b174f26114e8926a9f2128fe4',
                creationBlockNumber: 0,
            },
            mainnet: {
                address: '0x5f821c20947ff9be22e823edc5b3c709b33121b3',
                creationBlockNumber: 9119380,
            },
            rinkeby: {
                address: '0x162edb802fae75b9ee4288345735008ba51a4ec9',
                creationBlockNumber: 5628198,
            },
            mantle: {
                address: '0x88Ecc15fDC2985A7926171B938BB2Cd808A5ba40',
                creationBlockNumber: 127947,
            },
            'mantle-testnet': {
                address: '0x88Ecc15fDC2985A7926171B938BB2Cd808A5ba40',
                creationBlockNumber: 16210085,
            },
            core: {
                address: '0x88Ecc15fDC2985A7926171B938BB2Cd808A5ba40',
                creationBlockNumber: 8317448,
            },
            sepolia: {
                address: '0x88Ecc15fDC2985A7926171B938BB2Cd808A5ba40',
                creationBlockNumber: 4733363,
            },
        },
    },
}, '0.1.0');
